import { render, staticRenderFns } from "./videoAddressDetails.vue?vue&type=template&id=e7868e5a&scoped=true&"
import script from "./videoAddressDetails.vue?vue&type=script&lang=js&"
export * from "./videoAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoAddressDetails.vue?vue&type=style&index=0&id=e7868e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7868e5a",
  null
  
)

export default component.exports